<template>
    <main class="a-analytical-center a-main" id="a-analytical-center">
        <div class="a-main__container">
            <div class="a-main__title a-analytical-center__title">
                {{ title }}
            </div>
            <section class="a-analytical-center__wrapper">
                <div class="a-analytical-center__tabs">
                    <button
                        v-for="(tab, i) in tabs"
                        :key="i"
                        class="a-analytical-center__tab"
                        :class="{active: tabIndex == i}"
                        type="button"
                        @click.prevent="tabsContol(i)">
                        {{ tab }}
                    </button>
                </div>
                <div
                    class="a-analytical-center__filter">
                    <select-date-filter
                        @option-selected="optionSelected"
                        @date-selected="dateSelected"/>
                </div>
            </section>
            <section class="a-analytical-center__content"
                ref="resizeContainer">
                <section
                    v-show="tabIndex === 0"
                    class="a-analytical-center__list-wrap">
                    <loader v-if="pressReleaseIsLoading" />
                    <error v-if="pressReleaseError" />
                    <div
                        class="a-analytical-center__list">
                        <news-item
                            v-if="pressRelease && pressRelease.data.length !== 0"
                            :items-data="pressRelease" />
                        <empty-text
                            v-else
                            :empty-text="emptyText" />
                    </div>
                </section>
                <section
                    v-show="tabIndex === 1"
                    class="a-analytical-center__list-wrap">
                    <loader v-if="smiAboutUsIsLoading" />
                    <error v-if="smiAboutUsError" />
                    <div
                        class="a-analytical-center__list">
                        <news-item
                            v-if="smiAboutUs && smiAboutUs.data.length !== 0"
                            :items-data="smiAboutUs" />
                        <empty-text
                            v-else
                            :empty-text="emptyText" />
                    </div>
                </section>
            </section>
            <show-more-btn
                v-if="tabIndex === 0 && pressRelease && pressRelease.data.length > 6 ||
                    tabIndex === 1 && smiAboutUs && smiAboutUs.data.length > 6"
                :full-list="fullList"
                :desktop-small-device="desktopSmallDevice"
                :desktop-device="desktopDevice"
                :show-more="showMore"
                :has-mobile-device="hasMobileDevice"
                @toggleHeight="toggleHeight"/>
        </div>
    </main>
</template>

<script>
    import Loader from '../Loader'
    import Error from '../Error' 
    import NewsItem from '../NewsItem'
    import ShowMoreBtn from '../helpers/ShowMoreBtn'
    import EmptyText from '../helpers/EmptyText'
    import SelectDateFilter from '../helpers/SelectDateFilter'
    import {pressReleaseActionTypes} from '../../store/modules/press-release'
    import {smiAboutUsActionTypes} from '../../store/modules/smi-about-us'
    import {mapState} from 'vuex'

    import headerSearchHandler from '../../modules/a-main-nav'

    export default {
        name: 'AnalyticalCenter',
        components: {
            NewsItem,
            ShowMoreBtn,
            Loader,
            Error,
            SelectDateFilter,
            EmptyText
        },
        data() {
            return {
                apiUrl: '/api/v2/content/analytics',
                apiPressRelease: '/press-release/',
                apiSmiAboutUs: '/smi-about-us/',
                title: 'Аналитический центр в СМИ',
                tabs: [
                    'Пресс-релизы',
                    'Комментарии СМИ'
                ],
                tabIndex: 0,
                showMore: false,
                fullList: false,
                hasMobileDevice: true,
                resizeHeight: '',
                newsDataFilter: '',
                pressReleasePageCounter: 1,
                smiAboutUsPageCounter: 1,
                tabItemDataPageCounter: '',
                pageCounter: 1,
                currentAction: null,
                currentApi: null,
                selectedItem: '',
                filterParams: '',
                emptyText: 'По выбранным датам нет статей.',
            }
        },
        computed: {
            ...mapState({
                pressReleaseIsLoading: state => state.pressRelease.isLoading,
                pressRelease: state => state.pressRelease.data,
                pressReleaseError: state => state.pressRelease.error,
                smiAboutUsIsLoading: state => state.smiAboutUs.isLoading,
                smiAboutUs: state => state.smiAboutUs.data,
                smiAboutUsError: state => state.smiAboutUs.error
            }),
            mobileDevice () {
                return typeof window === 'object' && window.innerWidth < 768
            },
            tabletDevice () {
                return typeof window === 'object' && window.innerWidth >= 768 && window.innerWidth < 1025
            },
            desktopSmallDevice () {
                return typeof window === 'object' && window.innerWidth >= 1025 && window.innerWidth < 1200
            },
            desktopDevice () {
                return typeof window === 'object' && window.innerWidth >= 1200
            }
        },
        methods: {
            toggleHeight () {
                this.checkTabSettings()

                if (this.tabItemPageCounter !== this.pageCounter) {
                    if (this.tabIndex === 0) {
                        this.pressReleasePageCounter += 1
                        this.pageCounter = this.pressReleasePageCounter
                    } else {
                        this.smiAboutUsPageCounter += 1
                        this.pageCounter = this.smiAboutUsPageCounter
                    }

                    let filterParams = `${window.location.search}&`
                    
                    if (!window.location.search) {
                        filterParams = '?'
                    }

                    this.$store.dispatch(this.currentAction, {apiUrl: this.currentApi, newsDataFilter: `${filterParams}page=${this.pageCounter}`})
                    this.$refs.resizeContainer.style.height = `${this.$refs.resizeContainer.scrollHeight}px`
                } else {
                    if (this.$refs.resizeContainer.offsetHeight === this.$refs.resizeContainer.scrollHeight) {
                        this.$refs.resizeContainer.style.height = `${this.resizeHeight}px`;
                        this.showMore = false
                        return
                    }
                    this.$refs.resizeContainer.style.height = `${this.$refs.resizeContainer.scrollHeight}px`
                    setTimeout(() => {
                        if (this.$refs.resizeContainer.offsetHeight === this.$refs.resizeContainer.scrollHeight) {
                            this.showMore = true
                        }
                    }, 1000);
                }
            },

            setResizeContainerHeight () {
                this.resizeHeight = this.$refs.resizeContainer.offsetHeight;
                this.$refs.resizeContainer.style.height = `${this.resizeHeight}px`;
            },

            checkTabSettings () {
                if (this.tabIndex === 0) {
                    this.tabItemPageCounter = this.pressRelease.nav.NavPageCount
                    this.currentAction = pressReleaseActionTypes.getPressReleaseMoreData
                    this.currentApi = this.apiUrl + this.apiPressRelease
                    this.pageCounter = this.pressReleasePageCounter
                }   else {
                    this.tabItemPageCounter = this.smiAboutUs.nav.NavPageCount
                    this.currentAction = smiAboutUsActionTypes.getSmiAboutUsMoreData
                    this.currentApi = this.apiUrl + this.apiSmiAboutUs
                    this.pageCounter = this.smiAboutUsPageCounter
                }
            },

            tabsContol (index) {
                this.tabIndex = index
                this.checkTabSettings()
                this.$refs.resizeContainer.style.height = `${this.resizeHeight}px`
                setTimeout(() => {
                    if (this.tabItemPageCounter === this.pageCounter &&
                        this.$refs.resizeContainer.offsetHeight === this.$refs.resizeContainer.scrollHeight) {
                        this.showMore = true
                    } else {
                        this.showMore = false
                    }
                }, 1000)
            },

            defaultState () {
                this.pressReleasePageCounter = 1
                this.smiAboutUsPageCounter = 1
                this.$refs.resizeContainer.style.height = `${this.resizeHeight}px`
                this.showMore = false
            },

            optionSelected (id) {
                if (id === 'allTime') {
                    this.$store.dispatch(pressReleaseActionTypes.getPressRelease, {apiUrl: this.apiUrl + this.apiPressRelease, newsDataFilter: ''})
                    this.$store.dispatch(smiAboutUsActionTypes.getSmiAboutUs, {apiUrl: this.apiUrl + this.apiSmiAboutUs, newsDataFilter: ''})
                    history.pushState(null, null, window.location.href.split('?')[0]);
                }
                
                this.defaultState()
            },

            dateSelected (dateStart, dateEnd) {
                const dateFromParam = `?date-from=${dateStart}`
                const dateToParam = `&date-to=${dateEnd}`
                this.$store.dispatch(pressReleaseActionTypes.getPressRelease, {apiUrl: this.apiUrl + this.apiPressRelease, newsDataFilter: dateFromParam + dateToParam})
                this.$store.dispatch(smiAboutUsActionTypes.getSmiAboutUs, {apiUrl: this.apiUrl + this.apiSmiAboutUs, newsDataFilter: dateFromParam + dateToParam})
                history.pushState(null, null, `${window.location.href.split('?')[0]}${dateFromParam + dateToParam}`);
            }
        },
        mounted() {
            this.currentAction = pressReleaseActionTypes.getPressRelease
            this.currentApi = this.apiUrl + this.apiPressRelease
            this.$store.dispatch(this.currentAction, {apiUrl: this.currentApi, newsDataFilter: ''})
            this.$store.dispatch(smiAboutUsActionTypes.getSmiAboutUs, {apiUrl: this.apiUrl + this.apiSmiAboutUs, newsDataFilter: ''})
            this.setResizeContainerHeight()
            headerSearchHandler()
            history.pushState(null, null, window.location.href.split('?')[0]);
        }
    }
</script>